import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, RoutesRecognized } from '@angular/router';
import { BodyServ } from '../../body/body.service';
import { Header } from '../../header/header.class';
import { Ajax } from '../../services/ajax.service';

@Component({
  selector: 'pg-landing-madryn',
  templateUrl:'landing-madryn.component.html'
})

export class LandingMadrynComp implements OnInit{
  public section:any = false;
  public formSubmitedStatus = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public ajax : Ajax,
    public bodyServ : BodyServ
  ){}

  ngOnInit() {

    this.bodyServ.setSection(false);

    this.ajax.get('pagina/get/madryn/solicitar-informacion-madryn')
		.subscribe(
			res => {


			var resp:any = res;

      if(resp.tipo=='confirmo'){
        var sectAux = resp.resp.data;

        var articulos = {};

        for(var i in sectAux.articulos){
          articulos[sectAux.articulos[i].categoriaArticulo.codigo] = sectAux.articulos[i];
        }

        this.section = sectAux;
        this.section.articulos = articulos;
        this.bodyServ.setSection(this.section);
      }else{
        this.bodyServ.is404= true;
      }

			},
			error => console.error('Error: '),() => console.log('Hubo un error'));

		this.bodyServ.header.titulo = "Home";
		this.bodyServ.header.cod = '1';
    this.bodyServ.setIsPanel(false);
    this.bodyServ.setFooter(true);
  }

  formSubmited(e){
      if(e){
  			this.router.navigate(['gracias']);
        // this.formSubmitedStatus = true;
      }
  }

}
